<template>
    <Loader v-if="loading"/>
    <div v-if="loaded_data">
        <Card>
            <template #header>
                <div class="p-3 pb-0">
                    <h4>Dettagli del corso: {{ corso.nome }} [ {{ corso.type }} ]</h4>
                </div>
            </template>
            <template #content>
                <div class="col-12 flex">
                    <div class="col-12 flex flex-column md:col-4" >
                        <Card style="background-color: #0000ff;
                        text-align: center;
                        color: white;">
                            <template #title>Iscritti</template>
                            <template #content>
                                <h2>
                                    {{ totalPeople }} 
                                </h2>
                            </template>
                        </Card>
                    </div>
                    <div class="col-12 flex flex-column md:col-4">
                        <Card style="background-color: #689f38; text-align: center; color: white;">
                            <template #title>Incassato</template>
                            <template #content>
                                <h2>{{ totalPay }} &euro;</h2>
                            </template>
                        </Card>
                    </div>
                    <div class="col-12 flex flex-column md:col-4">
                        <Card style="background-color: #d32f2f; text-align: center; color: white;">
                            <template #title>Da incassare</template>
                            <template #content>
                                <h2>{{ totalToPay }}&euro;</h2>
                            </template>
                        </Card>
                    </div>
                </div>

                <div class="col-12 mt-3" v-if="corso.doc_stats && corso.doc_stats.length > 0">
                    <Accordion>
                        <AccordionTab header="Stato Documenti Obbligatori">
                            <div class="grid">
                                <div class="col-12 md:col-6 lg:col-3" v-for="stat in corso.doc_stats" :key="stat.doc_name">
                                    <div class="surface-card shadow-2 p-3 border-round">
                                        <div class="text-xl font-bold mb-3">{{ stat.doc_name }}</div>
                                        <div class="flex justify-content-between mb-2">
                                            <span>Totale:</span>
                                            <span class="font-bold">{{ stat.total_required }}</span>
                                        </div>
                                        <div class="flex justify-content-between mb-2 text-green-600">
                                            <span>Validi:</span>
                                            <span class="font-bold">{{ stat.valid }}</span>
                                        </div>
                                        <div class="flex justify-content-between mb-2 text-orange-500">
                                            <span>Scaduti:</span>
                                            <span class="font-bold">{{ stat.expired }}</span>
                                        </div>
                                        <div class="flex justify-content-between mb-2 text-red-600">
                                            <span>Mancanti:</span>
                                            <span class="font-bold">{{ stat.missing }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </AccordionTab>
                    </Accordion>
                </div>

                <Accordion :activeIndex="2"  >
                    <AccordionTab header="Dettagli">
                        <div class="flex align-items-start flex-wrap">
                            <div class="col-12 flex flex-wrap">
                                <div class="col-12 md:col-2 flex flex-column gap-2">
                                    <label for="type">Nome corso</label>
                                    <InputText id="type" v-model="corso.nome" :disabled="!update" :class="['inputfield w-full',{'p-invalid': submitted && validationErrors.type}]"/>
                                </div>
                                  <div class="p-field col-12 md:col-2">
                                    <label for="n_allenamenti">Numero incontri</label><br>
                                    <InputNumber id="n_allenamenti" v-model="corso.n_allenamenti" :class="['text_toupper inputfield w-full',{'p-invalid': submitted && validationErrors.mensile}]" :disabled="true"/>
                                    
                                </div>
                                <div class="p-field col-12 md:col-2">
                                    <label for="max_n_atleti">Capienza massima</label><br>
                                    <InputNumber id="max_n_atleti" v-model="corso.max_n_atleti" :class="['text_toupper inputfield w-full',{'p-invalid': submitted && validationErrors.mensile}]" :disabled="!update"/>
                                    
                                </div>
                                <div class="col-12 md:col-3 flex flex-column gap-2">
                                    <label>Data inizio</label>                   
                                    <Calendar :class="['inputfield w-full',{'p-invalid': submitted && validationErrors.data_inizio}]" v-model="corso.data_inizio" dateFormat="dd/mm/yy" showIcon :showOnFocus="false" :disabled="!update"/>
                                </div>
                                
                                <div class="col-12 md:col-3 flex flex-column gap-2">
                                    <label>Data fine</label>                   
                                    <Calendar :class="['inputfield w-full',{'p-invalid': submitted && validationErrors.data_fine}]" v-model="corso.data_fine" dateFormat="dd/mm/yy" showIcon :showOnFocus="false" :disabled="!update"/>
                                </div>
                                <div class="p-field col-12 md:col-2">
                                    <label for="price">Costo Annuale</label><br>
                                    <InputNumber id="price" v-model="corso.annuale" autofocus :class="['text_toupper inputfield w-full',{'p-invalid': submitted && validationErrors.annual_amount}]" :disabled="!update || iscritti.length > 0"/>
                                    
                                </div>
                                <div class="p-field col-12 md:col-2">
                                    <label for="pricesemestrale">Costo Semestrale</label><br>
                                    <InputNumber id="pricesemestrale" v-model="corso.semestrale" autofocus :class="['text_toupper inputfield w-full',{'p-invalid': submitted && validationErrors.semestrale}]" :disabled="!update || iscritti.length > 0"/>
                                    
                                </div>
                                <div class="p-field col-12 md:col-2">
                                    <label for="pricetrimestrale">Costo Trimestrale</label><br>
                                    <InputNumber id="pricetrimestrale" v-model="corso.trimestrale" autofocus :class="['text_toupper inputfield w-full',{'p-invalid': submitted && validationErrors.trimestrale}]" :disabled="!update || iscritti.length > 0"/>
                                    
                                </div>
                                <div class="p-field col-12 md:col-2">
                                    <label for="pricemensile">Costo Mensile</label><br>
                                    <InputNumber id="pricemensile" v-model="corso.mensile" autofocus :class="['text_toupper inputfield w-full',{'p-invalid': submitted && validationErrors.mensile}]" :disabled="!update || iscritti.length > 0"/>
                                    
                                </div>
                                <div class="p-field col-12 md:col-2">
                                    <label for="pricesettimanale">Costo Settimanale</label><br>
                                    <InputNumber id="pricesettimanale" v-model="corso.settimanale" autofocus :class="['text_toupper inputfield w-full',{'p-invalid': submitted && validationErrors.settimanale}]" :disabled="!update || iscritti.length > 0"/>
                                    
                                </div>
                                <div class="p-field col-12 md:col-2">
                                    <label for="ultima_rata">Rata fine corso € (opzionale)</label><br>
                                    <InputNumber id="ultima_rata" v-model="corso.ultima_rata" mode="decimal" :minFractionDigits="2" :maxFractionDigits="2" autofocus :class="['text_toupper inputfield w-full']" :disabled="!update || iscritti.length > 0"/>
                                </div>
                              
                              
                                
                                <div class="col-12 flex flex-wrap">
                                    <div class="col-12 md:col-6">
                                        <label class="mb-3">Responsabili</label>
                                        <div class="flex flex-column md:flex-row align-items-start md:align-items-center w-full gap-3">
                                            <Listbox v-model="selectedResponsabili" :options="responsabili" multiple optionLabel="name" filter filterPlaceholder="Cerca..." class="w-full md:w-20rem" v-if="update" listStyle="max-height:200px"/>
                                            <Button v-if="is_selectedResponsabili" icon="pi pi-angle-double-right" class="p-button-success" @click="addPersonale('responsabili')"/>
                                            <ul class="pl-0 mt-2 md:mt-0">
                                                <li v-for="(responsabile, indice) in corso.responsabili" :key="responsabile" class="flex align-items-center justify-content-between mb-2">
                                                    <Button @click="goToStaff(responsabile.id)" class="p-button-link" :label="responsabile.nome" />
                                                    <Button v-if="update" icon="pi pi-times" class="p-button-danger ml-2" @click="removePersonale('responsabili', indice, responsabile.id)" />
                                                </li>
                                            </ul>
                                        </div> 
                                    </div>
                                    
                                    <div class="col-12 md:col-6">
                                        <label class="mb-3">Allenatori</label>
                                        <div class="flex flex-column md:flex-row align-items-start md:align-items-center w-full gap-3">
                                            <Listbox v-model="selectedAllenatori" :options="allenatori" multiple optionLabel="name" filter filterPlaceholder="Cerca..." class="w-full md:w-20rem" v-if="update" listStyle="max-height:200px"/>
                                            <Button v-if="is_selectedAllenatori" icon="pi pi-angle-double-right" class="p-button-success" @click="addPersonale('allenatori')"/>
                                            <ul class="pl-0 mt-2 md:mt-0">
                                                <li v-for="(allenatore, indice) in corso.allenatori" :key="allenatore" class="flex align-items-center justify-content-between mb-2">
                                                    <Button @click="goToStaff(allenatore.id)" class="p-button-link" :label="allenatore.nome"></Button>  
                                                    <Button v-if="update" icon="pi pi-times" class="p-button-danger ml-2" @click="removePersonale('allenatori', indice, allenatore.id)"/>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                
                                <!-- Sezione Assegnazione Giorni Allenamento -->
                                <div class="col-12 mt-4" v-if="corso.allenatori && corso.allenatori.length > 0">
                                    <Card>
                                        <template #title>Assegnazione Giorni e Orari Allenamento</template>
                                        <template #content>
                                            <div class="overflow-auto mb-3">
                                                <table class="w-full">
                                                    <thead>
                                                        <tr>
                                                            <th class="p-2 text-left">Allenatore</th>
                                                            <th v-for="slot in courseTimeSlots" :key="slot.key" class="p-2 text-center" style="min-width: 100px">
                                                                <div class="font-bold whitespace-nowrap">{{ slot.dayLabel }}</div>
                                                                <div class="text-sm text-gray-600">{{ slot.start.slice(0,5) }} - {{ slot.end.slice(0,5) }}</div>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="allenatore in corso.allenatori" :key="allenatore.id" class="border-b">
                                                            <td class="p-2 font-bold">{{ allenatore.nome }}</td>
                                                            <td v-for="slot in courseTimeSlots" :key="slot.key" class="p-2 text-center">
                                                                <Button 
                                                                    :icon="isSlotAssigned(allenatore, slot) ? 'pi pi-check' : 'pi pi-minus'"
                                                                    :class="isSlotAssigned(allenatore, slot) ? 'p-button-success' : 'p-button-outlined p-button-secondary'"
                                                                    class="p-button-sm p-button-rounded"
                                                                    @click="toggleSlot(allenatore, slot)"
                                                                    :disabled="!update"
                                                                />
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            
                                            <div v-if="courseTimeSlots.length === 0" class="text-center p-3 text-gray-500">
                                                Nessuno slot temporale rilevato dalle sessioni.
                                            </div>
                                            
                                            <Button 
                                                v-if="update && corso.allenatori && corso.allenatori.length > 0" 
                                                label="Salva Assegnazioni" 
                                                icon="pi pi-save"
                                                class="p-button-primary mt-3"
                                                @click="saveCoachAssignments"
                                            />
                                        </template>
                                    </Card>
                                </div>
                                
                                <div class="p-field col-12 md:col-4">
                                    <label for="nota">Note</label><br>
                                    <TextArea id="nota" v-model="corso.nota" autofocus :class="['text_toupper inputfield w-full',{'p-invalid': submitted && validationErrors.nota}]" :disabled="!update"/>
                                    
                                </div>
                            </div>
                        </div>
                        <Button label="Cancella corso" v-if='update' class="p-button p-button-danger" @click="deleteCorso" />

                        <div class="col-12 flex justify-content-end align-items-center">
                            <label class="mr-2">{{!update ? 'Modifica' : 'Salva'}} dati</label>
                            <InputSwitch v-model="update" @change="changeUpdate"/>
                        </div>
                    </AccordionTab>
                    
                    <AccordionTab header="Sessioni previste">
                        <Button label="Aggiungi sessione" class="p-button p-button-danger" @click="openDialogAddDay" style="margin-bottom:5px"/>
                        <Button :label="showOnlyNext ? 'Mostra tutte' : 'Prossime'" class="p-button p-button-warning" @click="toggleNextSessions" style="margin-bottom:5px;float:right"/>
                        <DataTable :value="filteredSessioni" tableStyle="min-width: 50rem" paginator :rows="10" :rowsPerPageOptions="[10, 20, 50]" :rowClass="rowClass">
                            
                            <Column field="nomecampo" header="Campo" style="width:150px;">
                                <template #body="{ data }">
                                        <Button class="p-button-warning m-2" @click="openDialogCampo(data.id,data.id_corso)" :label="data.nomecampo"/>
                                    </template>
                            </Column>
                            <Column field="data_inizio" header="Data " style="width: 15rem;">
                                <template #body="{data}">
                                    <Button class="p-button m-2" @click="openDialogData(data.id,data.data_inizio,data.data_fine)" >{{ moment(data.data_inizio).locale('it').format('ddd DD/MM/Y') }}</Button>
                                </template>
                            </Column>
                            <Column field="data_inizio" header="Orario" style="width: 15rem;">
                                <template #body="{data}">
                                    <Button class="p-button m-2 p-button-default" @click="openDialogOrario(data.id,data.data_inizio,data.data_fine)" >{{ moment(data.data_inizio).format('H:mm:ss') }} - {{ moment(data.data_fine).format('H:mm:ss') }}</Button>
                                </template>
                            </Column>
                           <Column field="note" header="Note" style="width: 200px;">
                                <template #body="{ data }">
                                    <span v-html="data.note"></span>
                                </template>
                            </Column>
                            <Column field="mister_previsto" header="Mister" style="width: 150px;">
                                <template #body="{ data }">
                                    <span>{{ data.mister_previsto || '-' }}</span>
                                </template>
                            </Column>
                            <Column field="presenze" header="Presenze" style="width: 100px;">
                                
                                <template #body="{ data }">
                                    
                                        <Button class="p-button m-2" @click="openDialog(data.id,data.id_corso)" >{{ data.presenze }}</Button>
                                    </template>
                                </Column>

                            <Column field="assenze" header="Assenze" style="width: 5rem;">
                                <template #body="{data}">
                                    {{ parseInt(totalPeople) - data.presenze}}
                                    </template>
                                </Column>
                            <Column  style="width:100px;">
                                 
                                <template #body="{ data }">
                                    <div class="flex justify-content-end">
                                        <Button class="p-button-info m-2" @click="openDialogStaff(data.id,data.id_corso)" label="Assenze Staff"/>
                                       <!-- <Button label="Completa allenamento" class="p-button-success m-2" @click="completeSession(data.id)"/>-->
                                    </div>
                                </template>
                            </Column>
                        </DataTable>
                    </AccordionTab>

                    <AccordionTab header="Atleti iscritti">
                        <Button label="Aggiungi iscritto" class="p-button" @click="goToNewIscrizione" style="margin-bottom:5px"/>
                        <Button v-if="isCorsoFinito && iscritti.length > 0" 
                                label="Sposta tutti gli iscritti" 
                                icon="pi pi-arrows-h" 
                                class="p-button-warning ml-2" 
                                style="margin-bottom:5px" 
                                @click="openSpostaIscrittiDialog" 
                        />
                        <Button style="margin-bottom:5px;float:right"
                                    label="Invia Notifica"
                                    icon="pi pi-bell"
                                    class="p-button-outlined p-button-info"
                                    @click="openSendNotificationDialog"
                                />
                        <DataTable :value="iscritti" v-model:filters="iscrittiFilters" :globalFilterFields="['nome', 'cognome', 'codfis']" class="p-datatable-gridlines">
                            <template #header>
                                <div class="flex justify-content-end">
                                    <span class="p-input-icon-left">
                                        <i class="pi pi-search" />
                                        <InputText v-model="iscrittiFilters['global'].value" placeholder="Cerca atleta..." />
                                    </span>
                                </div>
                            </template>
                            <Column field="data_inizio" header="Iscrizione">
                                <template #body="{data}">
                                    {{ moment(data.data_inizio).format('DD/MM/Y') }}
                                </template>
                            </Column>
                            <Column field="cognome" header="Atleta">
                                <template #body="{data}">
                                    <Button class="p-button-link" @click="goToAtleta(data.id)" >{{ capitalize1(data.nome) }} {{ capitalize1(data.cognome) }}</Button>
                                </template>
                            </Column>
                            <Column field="datadinascita" header="Data di Nascita">
                                <template #body="{data}">
                                    {{ moment(data.datadinascita).format('DD/MM/Y') }}
                                </template>
                            </Column>
                            <Column header="Doc" style="width: 4rem; text-align: center">
                                <template #body="{data}">
                                    <i v-if="data.missing_docs && data.missing_docs.length > 0" 
                                       class="pi pi-exclamation-triangle text-red-500 text-xl" 
                                       v-tooltip.top="'Mancanti/Scaduti: ' + data.missing_docs.join(', ')"
                                    ></i>
                                    <i v-else class="pi pi-check-circle text-green-500 text-xl"></i>
                                </template>
                            </Column>
                            <Column field="stato" header="Stato">
                                <template #body="{ data }">
                                <Button v-if="data.n_rate == '-1'"
                                    class="data.n_rate == '-1' ? 'p-button-danger': 'p-button-success' m-3"
                                    :icon="data.n_rate == '-1' ? 'pi pi-question' : 'pi pi-check'"
                                    :label="data.n_rate == '-1' ? 'Completa' : 'Dettagli'"
                                    @click="setRate(data)"
                                />
                                </template>
                            </Column>
                            <Column field="presenze" header="Presenze"></Column>
                            <Column field="tessera" header="Tessera">
                                <template #body="{data}">
                                    <span v-html="data.tessera === 'NO' ? '<font style=\'color:red\'>NO</font>' : data.tessera"></span>
                                </template>
                            </Column>
                            <Column field="pagato" header="Pagato"></Column>
                            <Column field="da_pagare" header="Da pagare"></Column>
                            <Column field="lastpay" header="Ultimo pagamento" >
                                <template #body="{data}">
                                    <span :class="{ 'text-danger': !data.lastpay }">
                                     {{ data.lastpay ? new Date(data.lastpay).toLocaleDateString('it-IT') : 'Nessun pagamento' }}
                                     </span>
                                </template>
                            </Column>
                            <Column header="Notifica" style="width: 100px; text-align: center">
                                <template #body="{ data }">
                                    <Button 
                                        icon="pi pi-bell" 
                                        class="p-button-rounded p-button-warning p-button-sm" 
                                        @click="sendIndividualNotification(data)"
                                        v-tooltip="'Invia notifica per documenti mancanti'"
                                        :disabled="!data.missing_docs || data.missing_docs.length === 0"
                                    />
                                </template>
                            </Column>
                        </DataTable>
                    </AccordionTab>

                    <AccordionTab header="Richieste prova">
                     
                        <DataTable :value="richiesteprova" class="p-datatable-gridlines">
                            <Column field="creation_time" header="Data Richiesta">
                                <template #body="{data}">
                                    {{ moment(data.creation_time).format('DD/MM/Y H:mm:ss') }}
                                </template>
                            </Column>
                            <Column field="creation_time" header="Data Approvazione">
                                <template #body="{data}">
                                    {{ moment(data.data_approvazione).format('DD/MM/Y H:mm:ss') }}
                                </template>
                            </Column>
                            <Column field="cognome" header="Atleta">
                                <template #body="{data}">
                                    <Button class="p-button-link"  @click="goToAtleta(data.id_atleta)" >{{ capitalize1(data.atleta) }}</Button>
                                </template>
                            </Column>
                            <Column field="datadinascita" header="Data di Nascita">
                                <template #body="{data}">
                                    {{ moment(data.datadinascita).format('DD/MM/Y') }}
                                </template>
                            </Column>
                       
                        </DataTable>

                    </AccordionTab>

                    <AccordionTab header="Gallery">
                        <div class="card">
                            <div class="flex align-items-center gap-3 mb-4">
                                <FileUpload ref="fileUploadRef" mode="basic" name="demo[]" accept="image/*" :maxFileSize="5000000" :auto="true" customUpload @uploader="uploadImage" chooseLabel="Carica Immagine" />
                            </div>
                            
                            <div class="grid" v-if="galleryImages.length > 0">
                                <div class="col-12 md:col-3" v-for="image in galleryImages" :key="image.id">
                                    <div class="relative surface-card border-round shadow-2 p-2">
                                        <img :src="image.url" alt="Image" />
                                        <Button icon="pi pi-trash" class="p-button-rounded p-button-danger absolute top-0 right-0 m-2" @click="deleteImage(image.id)" />
                                    </div>
                                </div>
                            </div>
                            <div v-else class="mt-4 text-center">
                                <p>Nessuna immagine presente nella gallery.</p>
                            </div>
                        </div>
                    </AccordionTab>

                    <AccordionTab header="Riepilogo Pagamenti">
                        <DataTable :value="paymentSummary" class="p-datatable-gridlines" :paginator="true" :rows="12">
                            <Column field="mese_label" header="Mese">
                                <template #body="{data}">
                                    {{ data.mese_label }}
                                </template>
                            </Column>
                            <Column field="totale_incassato" header="Totale Incassato">
                                <template #body="{data}">
                                    € {{ parseFloat(data.totale_incassato).toFixed(2) }}
                                </template>
                            </Column>
                            <Column field="numero_paganti" header="Numero Paganti">
                                <template #body="{data}">
                                    {{ data.numero_paganti }}
                                </template>
                            </Column>
                            <Column field="tessere_pagate" header="Tessere Pagate">
                                <template #body="{data}">
                                    {{ data.tessere_pagate }}
                                </template>
                            </Column>
                            <Column header="Azioni" style="width: 10rem">
                                <template #body="{data}">
                                    <div class="flex gap-2">
                                        <Button icon="pi pi-search" class="p-button-rounded p-button-info p-button-text" @click="openPaymentDetails(data)" tooltip="Dettagli" />
                                        <Button icon="pi pi-download" class="p-button-rounded p-button-success p-button-text" @click="downloadPaymentCSV(data)" tooltip="Scarica CSV" />
                                    </div>
                                </template>
                            </Column>
                        </DataTable>
                    </AccordionTab>

                </Accordion>
            </template>
        </Card>
    </div>

    <Dialog v-model:visible="detailsDialogVisible" :header="'Dettaglio Pagamenti - ' + currentMonthLabel" :modal="true" :style="{width: '70vw'}">
        <DataTable :value="paymentDetails" class="p-datatable-gridlines" :paginator="true" :rows="10" responsiveLayout="scroll">
            <Column field="atleta" header="Atleta" sortable></Column>
            <Column field="importo" header="Importo" sortable>
                <template #body="{data}">
                    € {{ data.importo }}
                </template>
            </Column>
                <Column field="mensilita" header="Mensilità/Prodotto" sortable></Column>
            <Column field="metodo" header="Metodo" sortable></Column>
            <Column field="data_pagamento" header="Data Pagamento" sortable></Column>
        </DataTable>
            <template #footer>
            <Button label="Chiudi" icon="pi pi-times" @click="detailsDialogVisible = false" class="p-button-text"/>
        </template>
    </Dialog>

    <Dialog
    header="Invia Notifica"
    v-model:visible="showNotificationDialog"
    modal
    :style="{ width: '50vw' }"
>
    <div class="p-fluid">
        <div class="field mb-4">
            <label for="notificationTitle">Titolo</label>
            <InputText id="notificationTitle" v-model="notification.title" />
        </div>
        <div class="field mb-4">
            <label for="notificationBody">Messaggio</label>
            <Textarea
                id="notificationBody"
                v-model="notification.body"
                rows="5"
                cols="30"
            />
        </div>

        <div class="p-input-icon-left mb-3">
            <i class="pi pi-search"></i>
            <InputText v-model="searchText" placeholder="Cerca atleti..." class="w-full" />
        </div>
        <div class="mb-3 font-bold">
            Atleti selezionati: {{ selectedIscritti.length }}
        </div>

        <DataTable
            :value="filteredIscritti"
            dataKey="id"
            v-model:selection="selectedIscritti"
            :paginator="true"
            :rows="20"
            class="p-datatable-gridlines"
        >
            <Column selectionMode="multiple" headerStyle="width: 3em"></Column>
            <Column field="nome" header="Nome"></Column>
            <Column field="cognome" header="Cognome"></Column>

                            <Column field="presenze" header="Presenze"></Column>

                            <Column field="lastpay" header="Ultimo pagamento">
                                <template #body="{data}">
                                    {{ moment(data.lastpay).format('DD/MM/Y') }}
                                </template>
                            </Column>
        </DataTable>
    </div>

    <template #footer>
        <Button
            label="Annulla"
            icon="pi pi-times"
            class=""
            @click="closeSendNotificationDialog"
        />
        <Button
            label="Invia"
            icon="pi pi-send"
            @click="confirmSend"
            :disabled="!notification.title || !notification.body || selectedIscritti.length === 0"
        />
    </template>
</Dialog>
    <!-- Dialog per configurare i dettagli -->
    <Dialog header="Aggiungi Sessione" v-model:visible="dialogVisible" :modal="true" :closable="true">
      <div class="form-group">
        <label>Giorni della settimana:<br/></label>
        <div class="days-container">
          <Button
            v-for="(day, index) in days"
            :key="index"
            :label="day.label"
            :class="{ 'p-button-success': selectedDays.includes(day.value) }"
            @click="toggleDaySelection(day.value)"
          />
        </div>
        <p v-if="validationErrors.days" class="error-message">Seleziona almeno un giorno.</p>
      </div>

      <div class="form-group">
        <label for="startTime">Orario di inizio:</label>
        <Calendar
          id="startTime"
          :stepMinute="30"
          v-model="session.startTime"
          timeOnly
          hourFormat="24"
        />
        <p v-if="validationErrors.startTime" class="error-message">Seleziona un orario di inizio.</p>
      </div>

      <div class="form-group">
        <label for="endTime">Orario di fine:</label>
        <Calendar
          id="endTime"
          :stepMinute="30"
          v-model="session.endTime"
          timeOnly
          hourFormat="24"
        />
        <p v-if="validationErrors.endTime" class="error-message">Seleziona un orario di fine.</p>
        <p v-if="validationErrors.timeDifference" class="error-message">
          La differenza tra inizio e fine deve essere di almeno 30 minuti.
        </p>
      </div>

      <div class="form-group">
        Seleziona il nuovo campo  
        <Dropdown v-model="selectedCampo" :options="dialogCampi" optionLabel="nomecampo" class="text_toupper inputfield w-full" />
        </div>

      <div class="form-group">
        <Checkbox
          v-model="extendToEndOfCourse"
          inputId="extendCheckbox"
          binary
        />
        <label for="extendCheckbox"> Ripeti fino a fine corso (giugno)</label>
      </div>

      <div class="form-actions">
        <Button label="Salva" class="p-button-success" @click="validateAndSaveSession" />
        <Button label="Annulla" class="p-button-danger" @click="closeDialog" />
      </div>
    </Dialog>

    <DialogComponent
      :visible="isDialogVisible"
      :iscritti="dialogIscritti"
      @close="handleClose"
      @save="handleSave"
    />
    <DialogComponentStaff
      :visible="isDialogStaffVisible"
      :iscritti="dialogStaff"
      :staff="allStaff"
      @close="handleCloseStaff"
      @save="handleSaveStaff"
    />

    <DialogComponentOrario
      :visible="isDialogOrarioVisible"
      :startSlot="startSlot"
      :endSlot="endSlot"
      @close="handleCloseOrario"
      @save="handleSaveOrario"
    />
    <DialogComponentCampi
      :visible="isDialogCampiVisible"
      :campi="dialogCampi"
      @close="handleCloseCampi"
      @save="handleSaveCampi"
    />

    <Dialog header="Conferma Cambio Campo e Notifica" v-model:visible="isCampoNotifDialogVisible" modal :style="{ width: '40rem' }">
        <div class="p-fluid">
            <div class="field mb-3">
                <p>Il campo per la sessione è stato modificato. Vuoi inviare una notifica push agli utenti iscritti al corso?</p>
            </div>
            <div class="field mb-3">
                <label for="campoNotifTitle" class="font-bold">Titolo Notifica</label>
                <InputText id="campoNotifTitle" v-model="campoNotifTitle" class="w-full" />
            </div>
            <div class="field mb-3">
                <label for="campoNotifBody" class="font-bold">Testo Notifica</label>
                <Textarea id="campoNotifBody" v-model="campoNotifBody" rows="4" class="w-full" />
            </div>
        </div>
        <template #footer>
            <div class="flex justify-content-between w-full">
                <Button label="Annulla" icon="pi pi-times" class="p-button-text p-button-secondary" @click="cancelCampoChange" />
                <div>
                    <Button label="Salva senza notificare" icon="pi pi-check" class="p-button-outlined p-button-warning mr-2" @click="confirmCampoChangeWithoutNotif" />
                    <Button label="Conferma ed invia notifica" icon="pi pi-send" class="p-button-success" @click="confirmCampoChangeAndSendNotif" :disabled="!campoNotifTitle || !campoNotifBody" />
                </div>
            </div>
        </template>
    </Dialog>

    <DialogComponentData
        :visible="isDialogDataVisible"
        :daySlot="daySlot"
        @close="handleCloseData"
        @save="handleSaveData"
    />
    
    <Dialog header="Completa Iscrizione" v-model:visible="showDialogCompletaIscrizione" modal>
        <div class="flex col-12">
            <Button v-for="(mensilita, index) in mensilita_da_completare" :key="index" style="position:relative;" :class="`m-2 card p-button-${mensilita.selected ? 'info' : 'outlined'}`" @click="onSelectRata($event, index)">
                <div class="flex flex-column justify-content-center w-14rem">
                    <h3>€ {{ mensilita.importo * mensilita.n_rate }}</h3>
                    <p>
                        {{ mensilita.n_rate }} {{ mensilita.suffix }} da <b style="font-size: 20px;">{{ mensilita.importo }} €</b>
                    </p>
                    <h5>Piano {{ mensilita.descrizione }}</h5>
                </div>
            </Button>
        </div>
        Inserire l'importo della rata

                                    <InputNumber  v-model="importorata" :class="['text_toupper inputfield w-full']" />
        
        Da quando inizia a pagare?
        <div class="mt-5 mr-5 col-12 flex justify-content-center">
            <div class="month-buttons flex-wrap" v-if="!isWeeklyCourse">
      <button 
        v-for="month in months" 
        :key="month.value"
        @click="selectMonth(month)" 
        :class="['month-btn', selectedMonth === month.value ? 'selected' : '']"
      >
        {{ month.label }}
      </button>
    </div>
    <div class="month-buttons flex-wrap max-h-15rem overflow-y-auto" v-else>
      <button 
        v-for="week in weeks" 
        :key="week.value"
        @click="selectWeek(week)" 
        :class="['month-btn', selectedWeek === week.value ? 'selected' : '']"
      >
        {{ week.label }}
      </button>
    </div>
        </div>
        <div class="mt-5 mr-5 col-12 flex justify-content-center">
            <Button :disabled="!canUpdateIscrizione" class="p-button-success" icon="pi pi-check" label="Salva" @click="updateRateIscrizione"/>
        </div>
    </Dialog>

    <Dialog header="Sposta Tutti gli Iscritti in un Nuovo Corso" v-model:visible="showSpostaDialog" :modal="true" :style="{ width: '45vw' }">
        <div class="p-fluid">
            <p>
                Questo corso è terminato. Vuoi spostare tutti gli <b>{{ iscritti.length }}</b> atleti iscritti in un nuovo corso attivo?
            </p>
            <div class="field mt-4">
                <label for="targetCorso" class="font-bold mb-2 block">Seleziona il nuovo corso (data fine > oggi):</label>
                <Dropdown 
                    id="targetCorso" 
                    v-model="selectedTargetCorso" 
                    :options="futureCorsi" 
                    optionLabel="label" 
                    placeholder="Seleziona corso..." 
                    class="w-full"
                    :filter="true"
                />
            </div>
        </div>
        <template #footer>
            <Button label="Annulla" icon="pi pi-times" class="p-button-text" @click="closeSpostaIscrittiDialog" />
            <Button label="Sposta Iscritti" icon="pi pi-check" class="p-button-warning" :disabled="!selectedTargetCorso" @click="confirmSpostaIscritti" />
        </template>
    </Dialog>
</template>

<script>
import {ref, onMounted, getCurrentInstance, onUpdated, computed } from 'vue';
import { useRoute } from 'vue-router'
import { useConfirm } from "primevue/useconfirm";
import { useToast } from 'primevue/usetoast';
import { FilterMatchMode } from 'primevue/api';
import Loader from "@/components/Loader.vue"
import Service from '@/services/levante-api/levante-api'
import moment from 'moment'
import DialogComponent from '../DialogComponent.vue';
import DialogComponentStaff from '../DialogComponentStaff.vue';
import DialogComponentOrario from '../DialogComponentOrario.vue';
import DialogComponentData from '../DialogComponentData.vue';
import DialogComponentCampi from '../DialogComponentCampi.vue';
import ConfirmPopup from 'primevue/confirmpopup';
import Calendar from 'primevue/calendar';

export default {
  
    components: {
        Loader,
        DialogComponent,
        DialogComponentStaff,
        DialogComponentOrario,
        DialogComponentCampi,
        DialogComponentData,
        Calendar
    },

    methods: {
        capitalize1 (str){
        if (!str) return '';
        return str
          .toLowerCase()
          .split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
      },
    },


    setup () { 
        const self = getCurrentInstance();
        const toast = useToast();
        self.$eventBus = self.appContext.config.globalProperties.$eventBus
        const service = new Service(self.$eventBus)
        const loading = ref(false)
        const loaded_data = ref(false)
        const update = ref(false);
        const submitted = ref(false)
        const confirm = useConfirm();
        const route = useRoute()
        const id = route.params.id
        const iscrittiFilters = ref({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        });
        const corso = ref()
        const sessione = ref(0)
        const sessioni = ref([])
        const filteredSessioni = ref([]);
        const totalPeople = ref(0)
        const iscritti = ref([])
        const totalPay = ref(0)
        const totalToPay = ref(0)
        const dialogVisible = ref(false)
        const isDialogVisible = ref(false)
        const isDialogStaffVisible = ref(false)
        const isDialogOrarioVisible = ref(false)
        const isDialogDataVisible = ref(false)
        const isDialogCampiVisible = ref(false)
        const showOnlyNext = ref(true)
        const selectedSessionForCampo = ref(null)
        const isCampoNotifDialogVisible = ref(false)
        const pendingCampoChange = ref(null)
        const campoNotifTitle = ref('')
        const campoNotifBody = ref('')
        const selectedCampo = ref();
        //const inizioCorso = ref(new Date());
        const importorata=ref(0);
        const dialogIscritti = ref([]);
        const dialogStaff = ref([]);
        const dialogCampi = ref([]);
        const allStaff = ref([]);
        const lifeTime = 3000;
        const richiesteprova =ref([])
        const startSlot = ref();
        const daySlot = ref();
        const endSlot = ref();
        const showDialogCompletaIscrizione = ref(false);
        const mensilita_da_completare = ref()
        const iscrizione_da_aggiornare = ref({
            iscrizione: null,
            id_atleta:id,
            rata:[]
        })
        const allResponsabili = ref([])
        const responsabili = ref([])
        const selectedResponsabili = ref([])

        const allAllenatori = ref([])
        const allenatori = ref([])
        const selectedAllenatori = ref([]);
        const galleryImages = ref([]);
        const fileUploadRef = ref(null);
        const paymentSummary = ref([]);
        const detailsDialogVisible = ref(false);
        const paymentDetails = ref([]);
        const currentMonthLabel = ref('');

        const showSpostaDialog = ref(false);
        const futureCorsi = ref([]);
        const selectedTargetCorso = ref(null);

        const isCorsoFinito = computed(() => {
            if (!corso.value || !corso.value.data_fine) return false;
            return moment(corso.value.data_fine, ['DD/MM/YYYY', 'YYYY-MM-DD']).isBefore(moment(), 'day');
        });

        const openSpostaIscrittiDialog = async () => {
            loading.value = true;
            try {
                const res = await service.getCorsiAttivi();
                const items = res.items || res.data || [];
                futureCorsi.value = items.filter(c => {
                    if (c.id == id) return false;
                    const dtFine = moment(c.data_fine, ['DD/MM/YYYY', 'YYYY-MM-DD']);
                    return dtFine.isAfter(moment(), 'day');
                }).map(c => ({
                    ...c,
                    label: `${c.nome} (Fine: ${c.data_fine})`
                }));
                selectedTargetCorso.value = null;
                showSpostaDialog.value = true;
            } catch (err) {
                toast.add({ severity: 'error', summary: 'Errore', detail: 'Errore nel caricamento dei corsi', life: 3000 });
            } finally {
                loading.value = false;
            }
        };

        const closeSpostaIscrittiDialog = () => {
            showSpostaDialog.value = false;
            selectedTargetCorso.value = null;
        };

        const confirmSpostaIscritti = () => {
            if (!selectedTargetCorso.value) return;
            confirm.require({
                message: `Sei sicuro di voler spostare tutti i ${iscritti.value.length} atleti in "${selectedTargetCorso.value.nome}"?`,
                header: 'Conferma Spostamento',
                icon: 'pi pi-exclamation-triangle',
                accept: async () => {
                    loading.value = true;
                    try {
                        const res = await service.spostaIscrittiCorso(id, selectedTargetCorso.value.id);
                        const item = res.item || res;
                        if (item.esito === 'success') {
                            toast.add({ severity: 'success', summary: 'Successo', detail: item.messaggio, life: 3000 });
                            await getAtletiInCorso();
                        } else {
                            toast.add({ severity: 'warn', summary: 'Attenzione', detail: item.messaggio, life: 3000 });
                        }
                    } catch (err) {
                        toast.add({ severity: 'error', summary: 'Errore', detail: 'Errore durante lo spostamento degli iscritti', life: 3000 });
                    } finally {
                        showSpostaDialog.value = false;
                        loading.value = false;
                    }
                }
            });
        };


        const getGallery = async () => {
            try {
                const res = await service.getGalleryCorso(id);
                console.log('Gallery response:', res);
                if (res && res.items) {
                    console.log('Gallery response:', res.items);
                    if (Array.isArray(res.items.data)) {
                        galleryImages.value = res.items.data;
                        console.log('Gallery images set:', galleryImages.value);
                    }
                }
            } catch (error) {
                console.error('Error loading gallery:', error);
            }
        }

        const uploadImage = async (event) => {
            const file = event.files[0];
            const formData = new FormData();
            formData.append('image', file);
            formData.append('id_corso', id);

            try {
                const res = await service.uploadGalleryImage(formData);
                if (res && res.item && res.item.success) {
                    toast.add({ severity: 'success', summary: 'Successo', detail: 'Immagine caricata', life: 3000 });
                    getGallery();
                } else {
                    toast.add({ severity: 'error', summary: 'Errore', detail: 'Upload fallito', life: 3000 });
                }
            } catch (error) {
                toast.add({ severity: 'error', summary: 'Errore', detail: 'Upload fallito', life: 3000 });
            }

            // Clear the file input to allow selecting a new image
            if (fileUploadRef.value) {
                fileUploadRef.value.clear();
            }
        }

        const deleteImage = async (id_img) => {
            confirm.require({
                message: 'Sei sicuro di voler eliminare questa immagine?',
                header: 'Conferma Eliminazione',
                icon: 'pi pi-exclamation-triangle',
                accept: async () => {
                    try {
                        const res = await service.deleteGalleryImage(id_img);
                        if (res && res.item && res.item.success) {
                            toast.add({ severity: 'success', summary: 'Successo', detail: 'Immagine eliminata', life: 3000 });
                            getGallery();
                        } else {
                            toast.add({ severity: 'error', summary: 'Errore', detail: 'Eliminazione fallita', life: 3000 });
                        }
                    } catch (error) {
                        toast.add({ severity: 'error', summary: 'Errore', detail: 'Eliminazione fallita', life: 3000 });
                    }
                }
            });
        }

        const getPaymentSummary = async () => {
            try {
                const res = await service.getPaymentSummary(id);
                if (res && res.items && res.items.status) {
                    paymentSummary.value = res.items.payments || [];
                }
            } catch (error) {
                console.error('Error loading payment summary:', error);
            }
        }

        const openPaymentDetails = async (data) => {
            currentMonthLabel.value = data.mese_label;
            paymentDetails.value = [];
            try {
                const res = await service.getPaymentDetails(id, data.mese);
                 if (res && res.items && res.items.status) {
                    paymentDetails.value = res.items.details || [];
                    detailsDialogVisible.value = true;
                } else {
                     toast.add({ severity: 'error', summary: 'Errore', detail: 'Errore nel caricamento dettagli', life: 3000 });
                }
            } catch (error) {
                 toast.add({ severity: 'error', summary: 'Errore', detail: 'Errore nel caricamento dettagli', life: 3000 });
            }
        };

        const downloadPaymentCSV = async (data) => {
             try {
                const res = await service.getPaymentDetails(id, data.mese);
                 if (res && res.items && res.items.status) {
                     const details = res.items.details || [];
                     const csv = convertToCSV(details);
                     
                    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
                    const link = document.createElement("a");
                    if (link.download !== undefined) {
                        const url = URL.createObjectURL(blob);
                        link.setAttribute("href", url);
                        link.setAttribute("download", `pagamenti_${data.mese_label}.csv`);
                        link.style.visibility = 'hidden';
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    }
                }
             } catch(error) {
                  toast.add({ severity: 'error', summary: 'Errore', detail: 'Errore nel download CSV', life: 3000 });
             }
        };

        const convertToCSV = (objArray) => {
            if (!objArray || objArray.length === 0) return '';
            const array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
            let str = '';
            let header = Object.keys(array[0]).join(",") + '\r\n';
            str += header;

            for (let i = 0; i < array.length; i++) {
                let line = '';
                for (let index in array[i]) {
                    if (line != '') line += ','
                    line += array[i][index];
                }
                str += line + '\r\n';
            }
            return str;
        }

        onMounted(() => {
            getGallery();
            getPaymentSummary();
        });
    const days = ref([
      { label: "Lunedì", value: "1" },
      { label: "Martedì", value: "2" },
      { label: "Mercoledì", value: "3" },
      { label: "Giovedì", value: "4" },
      { label: "Venerdì", value: "5" },
      { label: "Sabato", value: "6" },
      { label: "Domenica", value: "0" },
    ]);
    
    const weekDays = ref([
        { value: '1', label: 'Lunedì', short: 'Lun' },
        { value: '2', label: 'Martedì', short: 'Mar' },
        { value: '3', label: 'Mercoledì', short: 'Mer' },
        { value: '4', label: 'Giovedì', short: 'Gio' },
        { value: '5', label: 'Venerdì', short: 'Ven' },
        { value: '6', label: 'Sabato', short: 'Sab' },
        { value: '0', label: 'Domenica', short: 'Dom' }
    ]);
    const selectedDays = ref([]);
    const session = ref({
      startTime: null,
      endTime: null,
    });
    const extendToEndOfCourse = ref(false);
    const validationErrors = ref({
      days: false,
      startTime: false,
      endTime: false,
      timeDifference: false,
    });

    const months = [
  { label: 'Settembre', value: 8 },
  { label: 'Ottobre', value: 9 },
  { label: 'Novembre', value: 10 },
  { label: 'Dicembre', value: 11 },
  { label: 'Gennaio', value: 0 },
  { label: 'Febbraio', value: 1 },
  { label: 'Marzo', value: 2 },
  { label: 'Aprile', value: 3 },
  { label: 'Maggio', value: 4 },
  { label: 'Giugno', value: 5 }
];

const selectedMonth = ref(null);
const selectedWeek = ref(null);
const inizioCorso = ref(null);
const showNotificationDialog = ref(false);
        const notification = ref({
            title: '',
            body: ''
        });
        const searchText = ref('');
        const selectedIscritti = ref([]);

        // Funzione per aprire la dialog
        const openSendNotificationDialog = () => {
            showNotificationDialog.value = true;
            selectedIscritti.value = [];
        };

        // Funzione per chiudere la dialog e resettare i campi
        const closeSendNotificationDialog = () => {
            showNotificationDialog.value = false;
            notification.value.title = '';
            notification.value.body = '';
            searchText.value = '';
            selectedIscritti.value = [];
        };

        // Logica per la ricerca
        const filteredIscritti = computed(() => {
            if (!searchText.value) {
                return iscritti.value;
            }
            const lowerSearchText = searchText.value.toLowerCase();
            return iscritti.value.filter(atleta =>
                atleta.nome.toLowerCase().includes(lowerSearchText) ||
                atleta.cognome.toLowerCase().includes(lowerSearchText)
            );
        });
        const confirmSend = (event) => {
            const numSelected = selectedIscritti.value.length;
            const message = `Sei sicuro di voler inviare la notifica a ${numSelected} persone?`;
            
            confirm.require({
                target: event.currentTarget,
                message: message,
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: 'Sì',
                rejectLabel: 'No',
                accept: () => {
                    sendNotification();
                }
            });
        };
        const sendIndividualNotification = (athlete) => {
            if (!athlete.id_utente) {
                toast.add({ severity: 'warn', summary: 'Attenzione', detail: 'Atleta non associato ad un utente app', life: 3000 });
                return;
            }

            const title = 'Documento obbligatorio mancante';
            const docs = athlete.missing_docs.join(', ');
            const body = `Gentile ${athlete.nome}, ti ricordiamo che mancano i seguenti documenti obbligatori: ${docs}. Caricali sull'app per regolarizzare la tua posizione.`;
            
            confirm.require({
                message: `Inviare notifica a ${athlete.nome} ${athlete.cognome}?\n\n"${body}"`,
                header: 'Conferma Invio Notifica',
                icon: 'pi pi-bell',
                accept: async () => {
                    loading.value = true;
                    try {
                        let fd = new FormData();
                        fd.append('user_id', athlete.id_utente);
                        fd.append('title', title);
                        fd.append('body', body);
                        
                        const res = await service.saveNotifica(fd);
                        const item = res.item || res;
                        if (item.esito === 'success') {
                            toast.add({ severity: 'success', summary: 'Successo', detail: item.messaggio, life: 3000 });
                        } else {
                            toast.add({ severity: 'warn', summary: 'Attenzione', detail: item.messaggio, life: 3000 });
                        }
                    } catch (error) {
                        toast.add({ severity: 'error', summary: 'Errore', detail: 'Errore invio notifica', life: 3000 });
                    } finally {
                        loading.value = false;
                    }
                }
            });
        };

        // Funzione per inviare la notifica
        const sendNotification = async () => {
            const userIds = selectedIscritti.value.map(iscritto => iscritto.id_utente);

            if (userIds.length === 0) {
                toast.add({
                    severity: 'warn',
                    summary: 'Nessun destinatario',
                    detail: 'Seleziona almeno un atleta a cui inviare la notifica.',
                    life: 3000,
                });
                return;
            }

            try {
                const payload = {
                    user_ids: userIds,
                    title: notification.value.title,
                    body: notification.value.body,
                };
                //console.log(payload)
                // Nota: ho cambiato l'endpoint per riflettere un invio multiplo
                await service.sendMessaggeGruppoSelezionati(payload).then((res) => {
                    
                        let severity = res.item.esito
                        let summary = res.item.esito != 'success' ? 'Attenzione' : 'Successo'
                        let detail = res.item.messaggio
                        
                        if (severity != 'warning') {
                            toast.add({severity:severity, summary: summary, detail:detail,life:lifeTime});                            
                        }
                        closeSendNotificationDialog();
                    
                });
            } catch (error) {
                console.error('Errore durante l\'invio della notifica:', error);
                toast.add({
                    severity: 'error',
                    summary: 'Errore',
                    detail: 'Si è verificato un errore durante l\'invio.',
                    life: 3000,
                });
            }
        };

// Puoi definire qui altre variabili ref o reactive necessarie per il tuo componente

const isWeeklyCourse = computed(() => {
  return corso.value && corso.value.settimanale > 1;
});

const weeks = computed(() => {
  if (!isWeeklyCourse.value) return [];
  const list = [];
  const startStr = corso.value.data_inizio; 
  const endStr = corso.value.data_fine;     
  
  if (!startStr || !endStr) return [];
  
  const start = moment(startStr, ['DD/MM/YYYY', 'YYYY-MM-DD']);
  const end = moment(endStr, ['DD/MM/YYYY', 'YYYY-MM-DD']);
  
  const current = start.clone();
  if (current.day() !== 1) {
    current.day(1);
    if (current.isBefore(start)) {
      current.add(7, 'days');
    }
  }
  
  while (current.isSameOrBefore(end)) {
    list.push({
      label: current.format('DD/MM/YYYY'),
      value: current.format('YYYY-MM-DD')
    });
    current.add(7, 'days');
  }
  return list;
});

const selectMonth = (month) => {
  selectedMonth.value = month.value;
  selectedWeek.value = null;
  
  // Creare una data con l'anno corrente e il mese selezionato
  const currentYear = new Date().getFullYear();
  let year = currentYear;
  
  // Aggiustare l'anno per i mesi da gennaio a giugno (che sarebbero nell'anno successivo)
  if (month.value > 6) {
    year = currentYear - 1;
  }
  
  inizioCorso.value = new Date(year, month.value, 1);
  
  // Ora puoi usare inizioCorso.value per qualsiasi operazione necessaria
  console.log('Mese di inizio corso selezionato:', inizioCorso.value);
  
  // Esempio di funzione che utilizza inizioCorso
  elaboraDataInizioCorso();
};

const selectWeek = (week) => {
  selectedWeek.value = week.value;
  selectedMonth.value = null;
  inizioCorso.value = moment(week.value, 'YYYY-MM-DD').toDate();
  console.log('Settimana di inizio corso selezionata:', inizioCorso.value);
};

const elaboraDataInizioCorso = () => {
  if (!inizioCorso.value) return;
  
  // Esempio: formattare la data per visualizzazione
  const formattedDate = `${inizioCorso.value.getMonth() + 1}/${inizioCorso.value.getFullYear()}`;
  console.log('Data formattata:', formattedDate);
  
  // Qui puoi inserire la tua logica di business
  // Per esempio: chiamare un'API, aggiornare altri stati, calcolare date correlate, ecc.
};
    // Methods
    const openDialogAddDay = async() => {
      await fetchCampi()
        .finally(()=>{
            dialogVisible.value = true;
        })
    };

    const closeDialog = () => {
      dialogVisible.value = false;
      resetForm();
    };

    const toggleDaySelection = (day) => {
      if (selectedDays.value.includes(day)) {
        selectedDays.value = selectedDays.value.filter((d) => d !== day);
      } else {
        if (selectedDays.value.length>0) selectedDays.value=[]
        selectedDays.value.push(day);
      }
    };

    const validateAndSaveSession = () => {
      // Reset validation errors
      validationErrors.value = {
        days: false,
        startTime: false,
        endTime: false,
        timeDifference: false,
      };

      let isValid = true;

      // Validate days
      if (selectedDays.value.length === 0) {
        validationErrors.value.days = true;
        isValid = false;
      }

      // Validate start time
      if (!session.value.startTime) {
        validationErrors.value.startTime = true;
        isValid = false;
      }

      // Validate end time
      if (!session.value.endTime) {
        validationErrors.value.endTime = true;
        isValid = false;
      }

      // Validate time difference
      if (session.value.startTime && session.value.endTime) {
        const start = new Date(session.value.startTime);
        const end = new Date(session.value.endTime);
        const differenceInMinutes = (end - start) / (1000 * 60);
        if (differenceInMinutes < 30) {
          validationErrors.value.timeDifference = true;
          isValid = false;
        }
      }

      // If valid, save the session
      if (isValid) {
        saveSession();
      }
    };

    const saveSession = () => {
      console.log("Giorni selezionati:", selectedDays.value);
      console.log("Orario di inizio:", session.value.startTime);
      console.log("Orario di fine:", session.value.endTime);
      console.log("Ripeti fino a giugno:", extendToEndOfCourse.value);

      let fd = new FormData();
        fd.append('selectedDays', selectedDays.value);
        fd.append('startTime', moment(session.value.startTime).format('H:m'));
        fd.append('endTime', moment(session.value.endTime).format('H:m'));
        fd.append('campo', selectedCampo.value.id);
        fd.append('corso', id);
        if (extendToEndOfCourse.value){
            fd.append('forever', 1);
        }else{
            fd.append("forever",0);
        }
        service.addDayInCourse(fd)
        .then((res) => {
            let severity = res.item.esito
            let summary = res.item.esito != 'success' ? 'Attenzione' : 'Successo'
            let detail = res.item.messaggio
            
            if (severity != 'warning') {
                toast.add({severity:severity, summary: summary, detail:detail,life:lifeTime});                            
            }
            getSessioni()
        }).finally(()=>{
            closeDialog();
        })
    };

    const resetForm = () => {
      selectedDays.value = [];
      session.value = {
        startTime: null,
        endTime: null,
      };
      extendToEndOfCourse.value = false;
      validationErrors.value = {
        days: false,
        startTime: false,
        endTime: false,
        timeDifference: false,
      };
    }
        const getStaff = async () => {
            await service.getStaff()
            .then((res) => {
                allStaff.value = res.items
                allResponsabili.value = allStaff.value.filter(staff => staff.is_responsabile == 'SI')
                allResponsabili.value.forEach(responsabile => {
                    if (corso.value.responsabili!=[]){
                        let index = corso.value.responsabili.findIndex(resp => resp.id == responsabile.id)
                        
                        if (index == -1) {
                            responsabili.value.push(responsabile)
                        }
                    }
                });
                allAllenatori.value = allStaff.value.filter(staff => staff.is_allenatore == 'SI')
                allAllenatori.value.forEach(allenatore => {
                    if (corso.value.allenatori!=[]){
                        let index = corso.value.allenatori.findIndex(all => all.id == allenatore.id)
                        if (index == -1) {
                            allenatori.value.push(allenatore)
                        }
                    }
                });
            })
        }

        const getDetails = async () => {
            await service.getDetails('corso', id)
            .then((res) => {
                console.log(res)
                if (res.items.success == 0){
                    toast.add({ severity: 'error', summary: 'Errore', detail: 'Non è stato possibile ottenere i dettagli del corso.' });
                }else{
                    corso.value = res.items.data[0]
                    corso.value.data_inizio = moment(corso.value.data_inizio).format('DD/MM/Y')
                    corso.value.data_fine = moment(corso.value.data_fine).format('DD/MM/Y')
                    loaded_data.value = true
                    getAtletiInCorso();
                    getSessioni();
                    getStaff();
                }
               
            })
        }
        const fetchIscrittiSezione = async (sessionId,corsoId) => {
            try {
                const res = await service.getIscrittiSezione(sessionId,corsoId);
                dialogIscritti.value = res.items;
            } catch (error) {
                console.error("Error fetching iscritti sezione", error);
                toast.add({ severity: 'error', summary: 'Errore', detail: 'Non è stato possibile ottenere gli iscritti.' });
            }
        };

        const fetchStaffCorso = async (sessionId,corsoId) => {
            try {
                const res = await service.getStaffCorso(sessionId,corsoId);
                dialogStaff.value = res.items;
            } catch (error) {
                console.error("Error fetching iscritti sezione", error);
                toast.add({ severity: 'error', summary: 'Errore', detail: 'Non è stato possibile ottenere gli iscritti.' });
            }
        };
        const fetchCampi = async () => {
            try {
                const res = await service.getCampi();
                dialogCampi.value = res.items;
            } catch (error) {
                toast.add({ severity: 'error', summary: 'Errore', detail: 'Non è stato possibile ottenere i campi.' });
            }
        };
        const openDialogCampo = async (sessionId,corsoId) => {
            loading.value = true
            sessione.value = sessionId
            selectedSessionForCampo.value = sessioni.value.find(s => s.id === sessionId)
            await fetchCampi()
            .finally(()=>{
                loading.value = false
            })
            isDialogCampiVisible.value = true;
        };
        const openDialogOrario = async (sessionId,start,end) => {
            
            sessione.value = sessionId
            startSlot.value=start
            endSlot.value=end
            isDialogOrarioVisible.value = true;
        };

        const openDialogData = async (sessionId,day) => {
            
            sessione.value = sessionId
            daySlot.value=day
            isDialogDataVisible.value = true;
        };


        const openDialogStaff = async (sessionId,corsoId) => {
            loading.value = true
            sessione.value = sessionId
            
            // Find the current session to get mister_previsto
            const currentSession = sessioni.value.find(s => s.id === sessionId)
            
            await fetchStaffCorso(sessionId,corsoId)
            .then(() => {
                // Pre-select assigned coaches as present
                if (currentSession && currentSession.mister_previsto) {
                    const misterNames = currentSession.mister_previsto.split(', ')
                    dialogStaff.value.forEach(staff => {
                        const fullName = `${staff.cognome} ${staff.nome}`
                        if (misterNames.includes(fullName)) {
                            staff.assente = false
                        }
                    })
                }
            })
            .finally(()=>{
                loading.value = false
            })
            isDialogStaffVisible.value = true;
        };

        const openDialog = async (sessionId,corsoId) => {
            loading.value = true
            sessione.value = sessionId
            await fetchIscrittiSezione(sessionId,corsoId)
            .finally(()=>{
                loading.value = false
                
                
            })
            isDialogVisible.value = true;
        };
        const handleClose = async () => {
            isDialogVisible.value = false;
        }
        const handleCloseStaff = async () => {
            isDialogStaffVisible.value = false;
        }
        const handleCloseCampi= async () => {
            isDialogCampiVisible.value = false;
        }
        const handleCloseOrario = async () => {
            isDialogOrarioVisible.value = false;
        }
        const handleCloseData = async()=>{
            isDialogDataVisible.value = false
        }

        const handleSaveData = async (data_in,forever)=> {
            // Logica per salvare le presenze aggiornate
            let fd = new FormData();
            fd.append('data_in', data_in);
            fd.append('sessionId', sessione.value);
            if (forever){
                fd.append('forever', 1);
            }else{
                fd.append("forever",0);
            }
            service.saveDataSessione(fd)
            .then((res) => {
                let severity = res.item.esito
                let summary = res.item.esito != 'success' ? 'Attenzione' : 'Successo'
                let detail = res.item.messaggio
                
                if (severity != 'warning') {
                    toast.add({severity:severity, summary: summary, detail:detail,life:lifeTime});                            
                }
                getSessioni()
            }).finally(()=>{
                isDialogCampiVisible.value = false;
            })
        }
        const handleSaveOrario = async (time_in,time_out,forever)=> {
            // Logica per salvare le presenze aggiornate
            let fd = new FormData();
            fd.append('time_in', time_in);
            fd.append('time_out', time_out);
            fd.append('sessionId', sessione.value);
            if (forever){
                fd.append('forever', 1);
            }else{
                fd.append("forever",0);
            }
            service.saveOrarioSessione(fd)
            .then((res) => {
                let severity = res.item.esito
                let summary = res.item.esito != 'success' ? 'Attenzione' : 'Successo'
                let detail = res.item.messaggio
                
                if (severity != 'warning') {
                    toast.add({severity:severity, summary: summary, detail:detail,life:lifeTime});                            
                }
                getSessioni()
            }).finally(()=>{
                isDialogCampiVisible.value = false;
            })
        }
        const handleSaveCampi = async (updatedCampo,forever)=> {
            pendingCampoChange.value = { campo: updatedCampo, forever };
            isDialogCampiVisible.value = false;
            
            campoNotifTitle.value = 'Cambio campo sessione di allenamento';
            const dateStr = selectedSessionForCampo.value ? moment(selectedSessionForCampo.value.data_inizio).locale('it').format('DD/MM/YYYY [alle] HH:mm') : '';
            const pitchName = updatedCampo ? (updatedCampo.nomecampo || '') : '';
            const courseName = (corso.value && (corso.value.nome || corso.value.nomecorso)) ? ` del corso ${corso.value.nome || corso.value.nomecorso}` : '';
            if (forever) {
                campoNotifBody.value = `Si avvisa che le sessioni di allenamento${courseName} a partire dal ${dateStr} si terranno presso il campo ${pitchName}.`;
            } else {
                campoNotifBody.value = `Si avvisa che la sessione di allenamento${courseName} del ${dateStr} si terrà presso il campo ${pitchName}.`;
            }
            isCampoNotifDialogVisible.value = true;
        }

        const confirmCampoChangeAndSendNotif = async () => {
            if (!pendingCampoChange.value) return;
            loading.value = true;
            try {
                let fd = new FormData();
                fd.append('campo', JSON.stringify(pendingCampoChange.value.campo));
                fd.append('sessionId', sessione.value);
                fd.append('forever', pendingCampoChange.value.forever ? 1 : 0);
                
                const resSave = await service.saveCampoSessione(fd);
                let severity = resSave.item.esito;
                let summary = resSave.item.esito !== 'success' ? 'Attenzione' : 'Successo';
                let detail = resSave.item.messaggio;
                
                if (severity !== 'warning') {
                    toast.add({ severity: severity, summary: summary, detail: detail, life: lifeTime });
                }

                const userIds = iscritti.value ? iscritti.value.map(i => i.id_utente).filter(id => !!id) : [];
                if (userIds.length > 0) {
                    const payload = {
                        user_ids: userIds,
                        title: campoNotifTitle.value,
                        body: campoNotifBody.value,
                    };
                    const resNotif = await service.sendMessaggeGruppoSelezionati(payload);
                    let notifItem = resNotif.item || resNotif;
                    if (notifItem.esito === 'success') {
                        toast.add({ severity: 'success', summary: 'Notifica inviata', detail: notifItem.messaggio || 'Notifica inviata agli utenti del corso.', life: lifeTime });
                    } else {
                        toast.add({ severity: 'warn', summary: 'Attenzione notifica', detail: notifItem.messaggio || 'Invio notifica fallito.', life: lifeTime });
                    }
                } else {
                    let fdNotif = new FormData();
                    fdNotif.append('id', id);
                    fdNotif.append('title', campoNotifTitle.value);
                    fdNotif.append('body', campoNotifBody.value);
                    
                    const resNotif = await service.sendNotificaGruppoCorso(fdNotif);
                    let notifItem = resNotif.item || resNotif;
                    if (notifItem.esito === 'success') {
                        toast.add({ severity: 'success', summary: 'Notifica inviata', detail: notifItem.messaggio || 'Notifica inviata agli utenti del corso.', life: lifeTime });
                    } else {
                        toast.add({ severity: 'warn', summary: 'Attenzione notifica', detail: notifItem.messaggio || 'Invio notifica fallito.', life: lifeTime });
                    }
                }

                getSessioni();
            } catch (error) {
                console.error('Errore durante il salvataggio o invio notifica:', error);
                toast.add({ severity: 'error', summary: 'Errore', detail: 'Errore durante l\'operazione', life: 3000 });
            } finally {
                loading.value = false;
                isCampoNotifDialogVisible.value = false;
                pendingCampoChange.value = null;
            }
        };

        const confirmCampoChangeWithoutNotif = async () => {
            if (!pendingCampoChange.value) return;
            loading.value = true;
            try {
                let fd = new FormData();
                fd.append('campo', JSON.stringify(pendingCampoChange.value.campo));
                fd.append('sessionId', sessione.value);
                fd.append('forever', pendingCampoChange.value.forever ? 1 : 0);
                
                const res = await service.saveCampoSessione(fd);
                let severity = res.item.esito;
                let summary = res.item.esito !== 'success' ? 'Attenzione' : 'Successo';
                let detail = res.item.messaggio;
                
                if (severity !== 'warning') {
                    toast.add({ severity: severity, summary: summary, detail: detail, life: lifeTime });
                }
                getSessioni();
            } catch (error) {
                toast.add({ severity: 'error', summary: 'Errore', detail: 'Errore nel salvataggio del campo', life: 3000 });
            } finally {
                loading.value = false;
                isCampoNotifDialogVisible.value = false;
                pendingCampoChange.value = null;
            }
        };

        const cancelCampoChange = () => {
            isCampoNotifDialogVisible.value = false;
            pendingCampoChange.value = null;
        };
        const handleSave = async (updatedIscritti)=> {
            // Logica per salvare le presenze aggiornate
            let fd = new FormData();
            fd.append('presenze', JSON.stringify(updatedIscritti));
            fd.append('sessionId', sessione.value);
            
            service.savePresenze(fd)
            .then((res) => {
                let severity = res.item.esito
                let summary = res.item.esito != 'success' ? 'Attenzione' : 'Successo'
                let detail = res.item.messaggio
                
                if (severity != 'warning') {
                    toast.add({severity:severity, summary: summary, detail:detail,life:lifeTime});                            
                }
                getSessioni()
            }).finally(()=>{
                isDialogVisible.value = false;
            })
        }
        const handleSaveStaff = async (updatedIscritti,alternativeStaff)=> {
            // Logica per salvare le presenze aggiornate
            let fd = new FormData();
            fd.append('assenze', JSON.stringify(updatedIscritti));
            fd.append('sessionId', sessione.value);
            fd.append('alternativeStaff', JSON.stringify(alternativeStaff));
            
            service.saveAssenzeStaff(fd)
            .then((res) => {
                let severity = res.item.esito
                let summary = res.item.esito != 'success' ? 'Attenzione' : 'Successo'
                let detail = res.item.messaggio
                
                if (severity != 'warning') {
                    toast.add({severity:severity, summary: summary, detail:detail,life:lifeTime});                            
                }
                getSessioni()
            }).finally(()=>{
                isDialogStaffVisible.value = false;
            })
        }
        const getAtletiInCorso = async () => {
            iscritti.value = []
            totalPay.value=0
            totalToPay.value=0
            await service.getAtletiInCorso(id)
            .then((res) => {
                iscritti.value = res.items
                iscritti.value.forEach(item => {
                    item.nome_completo = `${item.cognome} ${item.nome} - ${item.codfis}`
                    totalPay.value+=item.pagato
                    totalToPay.value+=item.da_pagare
                });
                totalPeople.value = iscritti.value.length

            })

            richiesteprova.value = []
            await service.getRichiesteProvaCorso(id)
            .then((res) => {
                richiesteprova.value = res.items
               
                
            })
        }

        const validateForm = () => {
            return true
        }
 
        const setRate = (data) => {
            mensilita_da_completare.value = data.mensilita
            iscrizione_da_aggiornare.value.iscrizione = data
            selectedMonth.value = null
            selectedWeek.value = null
            inizioCorso.value = null
            showDialogCompletaIscrizione.value = true
        }

        const onSelectRata = (evt, i) => {
            Object.keys(mensilita_da_completare.value).forEach(mensilita => {
                mensilita_da_completare.value[mensilita].selected = Number(mensilita) == i
            })
            importorata.value=mensilita_da_completare.value[i].importo
            iscrizione_da_aggiornare.value.rata = []
            iscrizione_da_aggiornare.value.rata.push(mensilita_da_completare.value[i])
        }
    
        const canUpdateIscrizione = computed(()=>{
            return iscrizione_da_aggiornare.value.rata.length
        })

        const availableWeekDays = computed(() => {
            if (!corso.value || !corso.value.giorni_allenamento || corso.value.giorni_allenamento.length === 0) {
                return weekDays.value
            }
            return weekDays.value.filter(day => 
                corso.value.giorni_allenamento.includes(parseInt(day.value))
            )
        })

        const updateRateIscrizione = async () => {
            loading.value = true
            let fd = new FormData();
            
            fd.append('iscrizione', JSON.stringify(iscrizione_da_aggiornare.value));
            if (inizioCorso.value){
                fd.append('inizioCorso', moment(inizioCorso.value).format('YYYY-MM-DD') );  
            }else{
                fd.append('inizioCorso', null );  
            }
            fd.append('importo',importorata.value);
            
            service.updateRateIscrizione(fd)
            .then((res) => {
                let severity = res.item.esito
                let summary = res.item.esito != 'success' ? 'Attenzione' : 'Successo'
                let detail = res.item.messaggio
                
                toast.add({severity:severity, summary: summary, detail:detail,life:lifeTime});                            
                onMounted()
                getAtletiInCorso()
            }).finally(() => {
                showDialogCompletaIscrizione.value = false
                loading.value = false
            })
        }
        const saveCorso = () => {
            submitted.value = true;
            validationErrors.value = []
            if(validateForm()){
                let fd = new FormData();
                fd.append('corso', JSON.stringify(corso.value));
                service.saveCorsoData(fd).then((res) => {
                    let severity = res.item.esito
                    let summary = res.item.esito != 'success' ? 'Attenzione' : 'Successo'
                    let detail = res.item.messaggio
                    toast.add({severity:severity, summary: summary, detail:detail});
                    update.value = res.item.esito != 'success' ? true : false;
                });
            }
        }
        const deleteCorso=() =>{
            let fd = new FormData();
                fd.append('corso', id);
                service.delCorsoData(fd).then((res) => {
                    let severity = res.item.esito
                    let summary = res.item.esito != 'success' ? 'Attenzione' : 'Successo'
                    let detail = res.item.messaggio
                    toast.add({severity:severity, summary: summary, detail:detail});
                    update.value = res.item.esito != 'success' ? true : false;
                    if ( res.item.esito =='success'){
                        window.open(`/mindtab`,"_self");
                    }
                });
        }
        const changeUpdate = () => {
            console.log("changeUpdate");
            if (!update.value) {
                saveCorso()
            }
        }
        const applySessioniFilter = () => {
            if (showOnlyNext.value) {
                const todayStart = moment().startOf('day');
                filteredSessioni.value = sessioni.value.filter((session) =>
                    moment(session.data_inizio).isSameOrAfter(todayStart)
                );
            } else {
                filteredSessioni.value = sessioni.value;
            }
        };

        const toggleNextSessions = () => {
            showOnlyNext.value = !showOnlyNext.value;
            applySessioniFilter();
        };

        const onlyNext = toggleNextSessions;

        const getSessioni = async () => {
            await service.getSessioni(id)
            .then((res) => {
                res.items.forEach(item => {
                    item.completata = item.completata ? 'Si' : 'No'
                });
                sessioni.value = res.items
                applySessioniFilter()
            })                
            
        }
        onMounted(() => { 
            loading.value = true
            mensilita_da_completare.value = null
            iscrizione_da_aggiornare.value = {
                iscrizione: null,
                id_atleta:id,
                rata:[]
            }
            showDialogCompletaIscrizione.value = false
            const promises = [getDetails()]
            
            Promise.all(promises)
            .finally(()=>{
                loading.value = false
            })
        })
        
        const goToAtleta = (idatleta)=> {
            window.open(`/atleta/${idatleta}/dettagli`)
        }
        const goToStaff = (id)=> {
            window.open(`/staff/${id}/dettagli`)
        }

        const isDaySelected = (coach, dayValue) => {
            if (!coach.giorni_allenamento) return false
            const days = coach.giorni_allenamento.split(',')
            return days.includes(dayValue)
        }

        const toggleCoachDay = (coach, dayValue) => {
            if (!coach.giorni_allenamento) {
                coach.giorni_allenamento = dayValue
            } else {
                const days = coach.giorni_allenamento.split(',')
                const index = days.indexOf(dayValue)
                if (index > -1) {
                    days.splice(index, 1)
                } else {
                    days.push(dayValue)
                }
                coach.giorni_allenamento = days.filter(d => d).join(',')
            }
        }

        const saveCoachDays = async () => {
            const assignments = corso.value.allenatori.map(coach => ({
                id: coach.id_personale_corsi,
                giorni: coach.giorni_allenamento || ''
            }))
            
            try {
                const res = await service.updateCoachDays(id, assignments)
                if (res.item.esito === 'success') {
                    toast.add({
                        severity: 'success',
                        summary: 'Successo',
                        detail: 'Giorni allenamento aggiornati',
                        life: 3000
                    })
                }
            } catch (error) {
                toast.add({
                    severity: 'error',
                    summary: 'Errore',
                    detail: 'Errore durante il salvataggio',
                    life: 3000
                })
            }
        }

        const getTimeSlotsForDay = (coach, dayValue) => {
            if (!coach.orari) coach.orari = []
            return coach.orari.filter(o => o.giorno_settimana == dayValue)
        }

        const addTimeSlot = (coach, dayValue) => {
            if (!coach.orari) coach.orari = []
            
            // Find sessions for this day to suggest times
            const daySessions = sessioni.value.filter(s => {
                // moment().day() returns: 0=Sun, 1=Mon, 2=Tue, ..., 6=Sat
                // Our dayValue format: 0=Sun, 1=Mon, 2=Tue, ..., 6=Sat
                const sessionDay = moment(s.data_inizio).day()
                return sessionDay == dayValue
            })
            
            console.log(`Found ${daySessions.length} sessions for day ${dayValue}`, daySessions)
            
            // Find a session time that hasn't been assigned yet
            let suggestedStart = null
            let suggestedEnd = null
            
            for (const session of daySessions) {
                const sessionStart = moment(session.data_inizio).format('HH:mm:ss')
                const sessionEnd = moment(session.data_fine).format('HH:mm:ss')
                
                console.log(`Checking session ${sessionStart}-${sessionEnd}`)
                
                // Check if this time slot is already assigned to this coach
                const alreadyAssigned = coach.orari.some(o => 
                    o.giorno_settimana == dayValue &&
                    o.ora_inizio && moment(o.ora_inizio).format('HH:mm:ss') === sessionStart
                )
                
                if (!alreadyAssigned) {
                    // Convert to Date objects for Calendar component
                    const today = new Date()
                    const [h1, m1, s1] = sessionStart.split(':').map(Number)
                    const [h2, m2, s2] = sessionEnd.split(':').map(Number)
                    suggestedStart = new Date(today.getFullYear(), today.getMonth(), today.getDate(), h1, m1, s1)
                    suggestedEnd = new Date(today.getFullYear(), today.getMonth(), today.getDate(), h2, m2, s2)
                    console.log('Suggesting:', suggestedStart, suggestedEnd)
                    break
                }
            }
            
            coach.orari.push({
                giorno_settimana: dayValue,
                ora_inizio: suggestedStart,
                ora_fine: suggestedEnd
            })
        }

        const removeTimeSlot = (coach, dayValue, index) => {
            const slots = coach.orari.filter(o => o.giorno_settimana == dayValue)
            const slotToRemove = slots[index]
            const globalIndex = coach.orari.indexOf(slotToRemove)
            coach.orari.splice(globalIndex, 1)
        }

        // Matrix Logic
        const courseTimeSlots = computed(() => {
            if (!sessioni.value) return []
            
            // 1. Collect all raw slots
            const rawSlots = []
            sessioni.value.forEach(s => {
                const day = moment(s.data_inizio).day() 
                const dayLabel = moment(s.data_inizio).format('dddd')
                const start = moment(s.data_inizio).format('HH:mm:ss')
                const end = moment(s.data_fine).format('HH:mm:ss')
                
                // Use a simple minutes-from-midnight value for easier comparison
                const startMins = moment(s.data_inizio).hour()*60 + moment(s.data_inizio).minute()
                const endMins = moment(s.data_fine).hour()*60 + moment(s.data_fine).minute()
                
                rawSlots.push({ day, dayLabel, start, end, startMins, endMins })
            })
            
            // 2. Sort by Day then Start
            rawSlots.sort((a,b) => {
                if (a.day !== b.day) return a.day - b.day
                return a.startMins - b.startMins
            })
            
            // 3. Cluster overlapping slots
            const clustered = []
            if (rawSlots.length > 0) {
                let current = { ...rawSlots[0] }
                
                for (let i = 1; i < rawSlots.length; i++) {
                    const next = rawSlots[i]
                    
                    // Same day and overlapping/touching?
                    // We treat "touching" as separate (e.g. 14-15 and 15-16 are distinct)
                    // Overlap means next.start < current.end
                    // To handle "fuzzy" alignment (like 13:30-15:00 vs 14:00-15:00), we act aggressively merging
                    // if the overlap is significant OR if they essentially cover the same block.
                    // User complained about 13:30-14:59 vs 13:45-15:00. This is overlap.
                    
                    if (next.day === current.day && next.startMins < current.endMins) {
                        // Merge!
                        current.startMins = Math.min(current.startMins, next.startMins)
                        current.endMins = Math.max(current.endMins, next.endMins)
                        
                        // Update formatted strings
                        // Re-format from mins is safer to standardise
                        current.start = moment().startOf('day').add(current.startMins, 'minutes').format('HH:mm:ss')
                        current.end = moment().startOf('day').add(current.endMins, 'minutes').format('HH:mm:ss')
                        
                    } else {
                        // Push current and start new
                        clustered.push(current)
                        current = { ...next }
                    }
                }
                clustered.push(current)
            }
            
            // 4. Generate keys and labels
            return clustered.map(s => {
                return {
                    key: `${s.day}-${s.start}-${s.end}`,
                    day: s.day,
                    dayLabel: s.dayLabel,
                    start: s.start,
                    end: s.end,
                    label: `${s.dayLabel} ${s.start.slice(0,5)}-${s.end.slice(0,5)}`
                }
            })
        })

        const isSlotAssigned = (coach, slot) => {
            // Implicit All Logic: If no orari AND no giorni set (null/empty), then YES
            const hasOrari = coach.orari && coach.orari.length > 0
            const hasDays = coach.giorni_allenamento && coach.giorni_allenamento.length > 0
            
            if (!hasOrari && !hasDays) return true
            
            if (hasOrari) {
                return coach.orari.some(o => {
                    if (o.giorno_settimana != slot.day) return false
                    
                    // Handle both String (newly added) and Date/String (from DB)
                    // If it's already a string in HH:mm:ss format, compare directly
                    if (typeof o.ora_inizio === 'string' && o.ora_inizio.length === 8) {
                         return o.ora_inizio === slot.start
                    }
                    
                    // Otherwise parse with moment
                    return moment(o.ora_inizio, ['HH:mm:ss', 'HH:mm']).format('HH:mm:ss') === slot.start
                })
            }
            
            // Fallback to days if no orari but days exist
            if (hasDays) {
                // giorni_allenamento string "1,3,5"
                const days = coach.giorni_allenamento.split(',').map(Number)
                return days.includes(slot.day)
            }
            
            return false
        }

        const toggleSlot = (coach, slot) => {
            const hasOrari = coach.orari && coach.orari.length > 0
            const hasDays = coach.giorni_allenamento && coach.giorni_allenamento.length > 0
            
            console.log(`ToggleSlot Coach ${coach.id}: HasOrari=${hasOrari}, HasDays=${hasDays}. SlotDay=${slot.day}`)

            // Ensure orari array exists
            if (!coach.orari) coach.orari = []

            // Helper to generate key consistent with courseTimeSlots
            const getSlotKey = (o) => {
                let s = o.ora_inizio
                let e = o.ora_fine
                // Normalize if moment object or mismatched string
                if (s && s.length !== 8) s = moment(s, ['HH:mm:ss', 'HH:mm']).format('HH:mm:ss')
                if (e && e.length !== 8) e = moment(e, ['HH:mm:ss', 'HH:mm']).format('HH:mm:ss')
                return `${o.giorno_settimana}-${s}-${e}`
            }

            // "Materialize" current state into explicit slots list
            let currentSlots = []
            
            if (!hasOrari && !hasDays) {
                // Implicit "All Available": Start with ALL slots
                currentSlots = courseTimeSlots.value.map(s => ({
                    giorno_settimana: s.day,
                    ora_inizio: s.start,
                    ora_fine: s.end,
                    key: s.key 
                }))
            } else if (!hasOrari && hasDays) {
                // Implicit "Days": Start with slots matching the days
                const days = coach.giorni_allenamento.split(',').map(Number)
                currentSlots = courseTimeSlots.value
                    .filter(s => days.includes(s.day))
                    .map(s => ({
                        giorno_settimana: s.day,
                        ora_inizio: s.start,
                        ora_fine: s.end,
                        key: s.key
                    }))
            } else {
                // Explicit "Slots": Start with existing orari
                currentSlots = coach.orari.map(o => ({...o, key: getSlotKey(o)}))
            }

            // Check if target slot is already in the list
            const idx = currentSlots.findIndex(o => {
                if (o.key && o.key === slot.key) return true
                // Fallback comparison
                if (o.giorno_settimana != slot.day) return false
                const startMatch = (o.ora_inizio === slot.start) || 
                                 (moment(o.ora_inizio, ['HH:mm:ss', 'HH:mm']).format('HH:mm:ss') === slot.start)
                return startMatch
            })

            if (idx !== -1) {
                // Remove
                currentSlots.splice(idx, 1)
            } else {
                // Add
                currentSlots.push({
                    giorno_settimana: slot.day,
                    ora_inizio: slot.start,
                    ora_fine: slot.end,
                    key: slot.key
                })
            }

            // Save back
            coach.orari = currentSlots
            if (currentSlots.length === 0) {
                coach.giorni_allenamento = 'NONE' // Explicitly set to NONE to prevent "All Available" fallback
            } else {
                coach.giorni_allenamento = '' 
            }
        }

        const saveCoachAssignments = async () => {
            // Save both giorni_allenamento and time slots
            const dayAssignments = corso.value.allenatori.map(coach => ({
                id: coach.id_personale_corsi,
                giorni: coach.giorni_allenamento || ''
            }))
            
            const timeSlots = corso.value.allenatori
                .filter(coach => coach.orari && coach.orari.length > 0)
                .map(coach => ({
                    id_personale_corsi: coach.id_personale_corsi,
                    slots: coach.orari.map(o => {
                        let start = o.ora_inizio
                        let end = o.ora_fine
                        
                        // Ensure format HH:mm:ss if it's a date object or non-standard string
                        if (start && start.length !== 8) {
                             const m = moment(start, ['HH:mm:ss', 'HH:mm'])
                             if (m.isValid()) start = m.format('HH:mm:ss')
                        }
                        if (end && end.length !== 8) {
                             const m = moment(end, ['HH:mm:ss', 'HH:mm'])
                             if (m.isValid()) end = m.format('HH:mm:ss')
                        }

                        return {
                            giorno: parseInt(o.giorno_settimana),
                            ora_inizio: start,
                            ora_fine: end
                        }
                    }).filter(s => s.ora_inizio && s.ora_fine)
                }))
            
            console.log('Sending Coach Assignments:', { dayAssignments, timeSlots })

            try {
                await service.updateCoachDays(id, dayAssignments)
                if (timeSlots.length > 0) {
                    await service.updateCoachTimeSlots(id, timeSlots)
                }
                toast.add({
                    severity: 'success',
                    summary: 'Successo',
                    detail: 'Assegnazioni aggiornate',
                    life: 3000
                })
                // Reload to refresh mister_previsto
                await getDetails()
            } catch (error) {
                toast.add({
                    severity: 'error',
                    summary: 'Errore',
                    detail: 'Errore durante il salvataggio',
                    life: 3000
                })
            }
        }


        const goToNewIscrizione = () => {
            window.open(`/add-iscrizione/${id}`)
        }
        const completeSession = async (id_sessione) => {
            loading.value = true
            let fd = new FormData()
            fd.append('id_sessione', id_sessione)
            await service.setCompleteSession(fd)
            .then(res => {
                console.log(res);
                let severity = res.item.esito
                let summary = res.item.esito != 'success' ? 'Attenzione' : 'Successo'
                let detail = res.item.messaggio
                if(res.item.esito == 'success'){
                    loading.value = true                    
                    Promise.all([getSessioni()])
                    .finally(()=>{
                        loading.value = false
                    })
                }

                toast.add({severity:severity, summary: summary, detail:detail, life: 10000});

            })
            .finally(()=>{
                loading.value = false
            })
        }
        const rowClass = (data) => {
            //return [{ 'bg-success': data.completata == 'Si' }];
        };

        const removePersonale = (tipo_personale, indice, id) => {
            let array_tipo_personale = corso.value[tipo_personale]
            
            array_tipo_personale.splice(indice, 1)           
            
            let array_personale
            let array_all_personale

            if (tipo_personale == 'responsabili') {
                array_personale = responsabili.value
                array_all_personale = allResponsabili.value

            } else {
                array_personale = allenatori.value
                array_all_personale = allAllenatori.value
            }

            array_personale.push(array_all_personale.find(pers => pers.id == id))
        }

        const is_selectedResponsabili = computed(()=>{
            return selectedResponsabili.value.length
        })
        const is_selectedAllenatori = computed(()=>{
            return selectedAllenatori.value.length
        })

        const addPersonale = (tipo_personale) => {
            let array_personale
            let array_selected

            if (tipo_personale == 'responsabili') {
                array_personale = responsabili.value
                array_selected = selectedResponsabili.value

            } else {
                array_personale = allenatori.value
                array_selected = selectedAllenatori.value
            }

            array_selected.forEach(selected_personale => {
                selected_personale.nome = selected_personale.name.trim()
                corso.value[tipo_personale].push(selected_personale)

                let index = array_personale.findIndex(personale => personale.id == selected_personale.id)
                array_personale.splice(index, 1)
            })
            if (tipo_personale == 'responsabili') {
                selectedResponsabili.value = []
            } else {
                selectedAllenatori.value = []
            }
        }

        return {
            iscrittiFilters,
            moment,
            loading,
            loaded_data,
            corso,
            update,
            submitted,
            changeUpdate,
            validationErrors,
            openDialogAddDay,
            closeDialog,
            toggleDaySelection,
            selectedDays,
            validateAndSaveSession,
            getSessioni,
            extendToEndOfCourse,
            days,
            sessioni,
            session,
            totalPeople,
            totalPay,
            totalToPay,
            showDialogCompletaIscrizione,
            getAtletiInCorso,
            iscritti,
            filteredSessioni,
            onlyNext,
            goToAtleta,
            openDialog,
            openDialogStaff,
            openDialogCampo,
            openDialogData,
            openDialogOrario,
            isDialogOrarioVisible,
            isDialogDataVisible,
            inizioCorso,
            importorata,
            selectedMonth,
            selectMonth,
            selectedWeek,
            selectWeek,
            isWeeklyCourse,
            weeks,
            sendIndividualNotification,
            months,
            handleSave,
            handleSaveOrario,
            dialogVisible,
            isDialogVisible,
            isDialogStaffVisible,
            handleCloseCampi,
            dialogIscritti,
            dialogStaff,
            dialogCampi,
            selectedCampo,
            deleteCorso,
            allStaff,
            setRate,
            goToStaff,
            endSlot,
            startSlot,
            daySlot,
            canUpdateIscrizione,
            updateRateIscrizione,
            handleClose,
            handleCloseData,
            goToNewIscrizione,
            completeSession,
            rowClass,
            handleSaveData,
            handleSaveStaff,
            handleCloseStaff,
            onSelectRata,
            mensilita_da_completare,
            isDialogCampiVisible,
            handleSaveCampi,
            showOnlyNext,
            toggleNextSessions,
            isCampoNotifDialogVisible,
            campoNotifTitle,
            campoNotifBody,
            confirmCampoChangeAndSendNotif,
            confirmCampoChangeWithoutNotif,
            cancelCampoChange,
            richiesteprova,
            removePersonale,
            handleCloseOrario,
            addPersonale,
            responsabili,
            allenatori,
            selectedResponsabili,
            selectedAllenatori,
            is_selectedResponsabili,
            is_selectedAllenatori,
            showNotificationDialog,
            notification,
            searchText,
            selectedIscritti,
            filteredIscritti,
            openSendNotificationDialog,
            closeSendNotificationDialog,
            sendNotification,
            confirmSend,
            galleryImages,
            fileUploadRef,
            uploadImage,
            deleteImage,
            paymentSummary,
            iscrizione_da_aggiornare,
            allResponsabili,
            allAllenatori,
            elaboraDataInizioCorso,
            saveSession,
            detailsDialogVisible,
            paymentDetails,
            currentMonthLabel,
            openPaymentDetails,
            downloadPaymentCSV,
            weekDays,
            availableWeekDays,
            isDaySelected,
            toggleCoachDay,
            saveCoachDays,
            getTimeSlotsForDay,
            addTimeSlot,
            removeTimeSlot,
            saveCoachAssignments,
            courseTimeSlots,
            isSlotAssigned,
            toggleSlot,
            isCorsoFinito,
            showSpostaDialog,
            futureCorsi,
            selectedTargetCorso,
            openSpostaIscrittiDialog,
            closeSpostaIscrittiDialog,
            confirmSpostaIscritti
        }
    }
}
</script>

<style>
    .bg-success{
        background-color: #10b982 !important;
        color: white !important;
    }

    .days-container {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 15px;
}

.form-group {
  margin-bottom: 15px;
}

.form-actions {
  display: flex;
  justify-content: space-between;
}

.p-button-success {
  background-color: #28a745 !important;
}

.p-button-danger {
  background-color: #dc3545 !important;
}
.error-message {
  color: red;
  font-size: 0.875rem;
}
.month-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  justify-content: center;
}

.month-btn {
  padding: 10px 5px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: #f8f9fa;
  cursor: pointer;
  transition: all 0.2s;
}

.month-btn:hover {
  background-color: #e9ecef;
}

.month-btn.selected {
  background-color: #0288D1;
  color: white;
  border-color: #0288D1;
}
.max-h-15rem {
  max-height: 15rem;
}
.overflow-y-auto {
  overflow-y: auto;
}
.text-danger {
    color:red !important;   
}


</style>